import fetchApi from "../../services/FetchApi";
import { currentAccessToken, isSignedOut } from "../../services/SessionApi";

export type SessionUser = {
	id: string;
	name: string;
	username: string;
	avatar: string;
};

export type Session = { jwt: string; user: SessionUser };

const toUser = (data: any): SessionUser => ({
	id: data.id,
	name: data.name || "",
	username: data.username || "",
	avatar: data.high_resolution_avatar || data.avatar || "",
});

export async function restoreSession(): Promise<Session | null> {
	let jwt: string;
	try {
		jwt = (await currentAccessToken()).accessToken;
	} catch (err) {
		if (isSignedOut(err)) return null;
		throw err;
	}
	return { jwt, user: toUser(await fetchApi.currentUser(jwt)) };
}
